import React, { useState } from "react";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { handlePostRequest } from "../../services/PostTemplate";

const ChangeCardPin = () => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("");

    const validationSchema = Yup.object().shape({
        cardNumber: Yup.string().required("This field is required.").min(16, "Card Number must be 16 digits").max(16, "Card Number must be 16 digits"),
        oldPin: Yup.string().required("This field is required.").min(4, "Pin must be 4 digits").max(4, "Pin must be 4 digits"),
        newPin: Yup.string().required("This field is required.").min(4, "Pin must be 4 digits").max(4, "Pin must be 4 digits"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            cardNumber: "",
            oldPin: "",
            newPin: "",
        },
        onSubmit: async (data) => {
            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                await handlePostRequest(data, "zbizgateway/accountMaintainence/changeCardPin");
            } catch (error) {
                console.error("An error occurred:", error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };
    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1> Change Card Pin </h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-6">
                        <div className="p-field">
                            <label htmlFor="cardNumber" className={classNames({ "p-error": isFormFieldValid("cardNumber") }, "Label__Text")}>
                                Atm Card Number<span className="Label__Required">*</span>
                            </label>
                            <InputText id="cardNumber" placeholder="" name="cardNumber" value={formik?.values?.cardNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("cardNumber") }, "Input__Round")} keyfilter={/^[0-9]+$/} />

                            {getFormErrorMessage("cardNumber")}
                        </div>
                        <div className="p-field">
                            <label htmlFor="oldPin" className={classNames({ "p-error": isFormFieldValid("oldPin") }, "Label__Text")}>
                                Old Pin<span className="Label__Required">*</span>
                            </label>
                            <InputText id="oldPin" placeholder="" name="oldPin" value={formik?.values?.oldPin?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("oldPin") }, "Input__Round")} />

                            {getFormErrorMessage("oldPin")}
                        </div>
                        <div className="p-field">
                            <label htmlFor="newPin" className={classNames({ "p-error": isFormFieldValid("newPin") }, "Label__Text")}>
                                New Pin<span className="Label__Required">*</span>
                            </label>
                            <InputText id="newPin" placeholder="" name="newPin" value={formik?.values?.newPin?.replace(/\s\s+/g, " ")} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("newPin") }, "Input__Round")} />

                            {getFormErrorMessage("newPin")}
                        </div>
                    </div>
                </div>

                <div className="Down__Btn">
                    <Button disabled={loading} icon={loadingIcon || ""} iconPos="right" label={"Search"} className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
};

export default ChangeCardPin;
